import { createContext, useContext } from 'react';
var stripeContext = /*#__PURE__*/createContext(undefined);
export var useCommerceStripe = function useCommerceStripe() {
  return useContext(stripeContext);
};
export var StripeProvider = stripeContext.Provider;